module.exports = __webpack_public_path__ + "static/media/restart.13af9647.svg";